// Dependency-free so `lib/` stays a leaf and bootstrap can match the class. Never import the hook here.
import { ApiError, isRecaptchaError, type RecaptchaAction } from '@platform/api';

export class RecaptchaError extends Error {
  readonly action: RecaptchaAction;
  constructor(action: RecaptchaAction, options?: ErrorOptions) {
    super(`reCAPTCHA failed for action "${action}"`, options);
    // Keeps `instanceof` intact through the plugin-legacy class downlevel.
    Object.setPrototypeOf(this, RecaptchaError.prototype);
    this.name = 'RecaptchaError';
    this.action = action;
  }
}

/** Both ends of the gate: the client cannot mint a token, or the BFF middleware rejects the one it got. */
export function isRecaptchaBlocked(error: unknown): boolean {
  return error instanceof RecaptchaError || (error instanceof ApiError && isRecaptchaError(error));
}
